import NotificationTypes from './notifications.types';
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import { clearLocalStorage } from '../../utils/commonFunctions';
import UtilsTypes from '../utilities/utils.types';
import Loader from '../../utils/Loader';

function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

function* fetchNotifications() {
	try {
		const res = yield call(Api, {
			url: 'notifications',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res.message);
		} else {
			Loader.hide();
			yield put({
				type: NotificationTypes.FETCH_NOTIFICATIONS.SUCCESS,
				payload: res.data.notifications,
			});
		}
	} catch (err) {
		console.log('notifications', err);
	}
}

function* fetchNotificationsStart() {
	yield takeLatest(
		NotificationTypes.FETCH_NOTIFICATIONS.PENDING,
		fetchNotifications,
	);
}

export function* notificationSagas() {
	yield all([call(fetchNotificationsStart)]);
}
